var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-header-template',{attrs:{"isPrimary":_vm.isPrimary,"renderNamespace":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }